/* eslint-disable */
const { Providers } = require('@/components/dialogs/AnalyticsEventTrackingSettingsDialog/provider_id_names');

const USER_ID_PARAM_NAME = 'User ID';

const FacebookAnalyticsProvider = {
	init: (trackers) => {
		!(function (f, b, e, v, n, t, s) {
			if (f.fbq) return;

			n = f.fbq = function () {
				n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
			};

			if (!f._fbq) f._fbq = n;
			n.push = n;
			n.loaded = !0;
			n.version = '2.0';
			n.queue = [];
			t = b.createElement(e);
			t.async = !0;
			t.src = v;
			s = b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t, s);
		})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
		for(const tracker of trackers){
			fbq('init', tracker.identifier);	
		}
		fbq('track', 'PageView');
	},

	track: ({action, pixel_id, event, metadata}) => {
		fbq(action, pixel_id, event, metadata);
	},
};

const GoogleAnalyticsProvider = {
	init: (trackers) => {
		const script = document.createElement('script');
		script.src = `https://www.googletagmanager.com/gtag/js?id=${trackers[0].identifier}`;
		script.async = true;
		document.head.appendChild(script);
		window.dataLayer = window.dataLayer || [];
		window.gtag = function () {
			dataLayer.push(arguments);
		};
		gtag('js', new Date());
		for (const tracker of trackers){
			gtag('config', tracker.identifier);
		}
	},

	track: ({ event_name, metadata }) => {
		gtag('event', event_name, metadata);
	},
};

const SegmentAnalyticsProvider = {
	init: (trackers) => {
		const id = trackers[0].identifier;
		!function(){
			var i="segmentAnalytics",analytics=window[i]=window[i]||[];
			if(!analytics.initialize)
				if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");
				else{
					analytics.invoked=!0;
					analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];
					analytics.factory=function(e){
						return function(){
							if(window[i].initialized)return window[i][e].apply(window[i],arguments);
							var n=Array.prototype.slice.call(arguments);
							if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){
								var c=document.querySelector("link[rel='canonical']");
								n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})
							}
							n.unshift(e);
							analytics.push(n);
							return analytics
						}
					};
					for(var n=0;n<analytics.methods.length;n++){
						var key=analytics.methods[n];
						analytics[key]=analytics.factory(key)
					}
					analytics.load=function(key,n){
						var t=document.createElement("script");
						t.type="text/javascript";
						t.async=!0;
						t.setAttribute("data-global-segment-analytics-key",i);
						t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
						var r=document.getElementsByTagName("script")[0];
						r.parentNode.insertBefore(t,r);
						analytics._loadOptions=n
					};
					analytics._writeKey=id;
					analytics.SNIPPET_VERSION="5.2.0";
		segmentAnalytics.load(id);
		segmentAnalytics.page();
		}}();
	},
	track: ({event, identifyParams, metadata}) => {
		if (identifyParams){
			const segmentUserId = identifyParams[USER_ID_PARAM_NAME];
			delete identifyParams[USER_ID_PARAM_NAME];
			if (segmentUserId){
				segmentAnalytics.identify(segmentUserId, identifyParams);
			}else{
				segmentAnalytics.identify(identifyParams);
			}
		}
		segmentAnalytics.track(event, metadata);
	}
}

const TikTokAnalyticsProvider = {
	init: (trackers) => {
		!function (w, d, t) {
  			w.TiktokAnalyticsObject=t;
			var ttq=w[t]=w[t]||[];
			ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],
			ttq.setAndDefer=function(t,e){
				t[e]=function(){
					t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
					for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
					ttq.instance=function(t){for(
					var e=ttq._i[t]||[],n=0;
					n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
					;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
  		for (const tracker of trackers){
			ttq.load(tracker.identifier);
		}
		ttq.page();
		}
		(window, document, 'ttq');
	},
	track: ({event, metadata, tracker_id}) => {
		ttq.instance(tracker_id).track(event, metadata);
	}
}

const MixpanelAnalyticsProvider = {
	init: (trackers) => {
		(function (f, b) { 
			if (!b.__SV) {
				var e, g, i, h;
				window.mixpanel = b;
				b._i = [];
				b.init = function (e, f, c) { 
					function g(a, d) { 
						var b = d.split(".");
						2 == b.length && ((a = a[b[0]]), (d = b[1]));
						a[d] = function () { 
							a.push([d].concat(Array.prototype.slice.call(arguments, 0)));
						};
						}
						var a = b;
						"undefined" !== typeof c ? (a = b[c] = []) : (c = "mixpanel");
						a.people = a.people || [];
						a.toString = function (a) {
								var d = "mixpanel";
								"mixpanel" !== c && (d += "." + c);
								a || (d += " (stub)");
								return d;
								};
								a.people.toString = function () {
									return a.toString(1) + ".people (stub)";
									};
									i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split( " ");
									for (h = 0; h < i.length; h++) g(a, i[h]);
									var j = "set set_once union unset remove delete".split(" ");
									a.get_group = function () {
										function b(c) {
											d[c] = function () {
												call2_args = arguments;
												call2 = [c].concat(Array.prototype.slice.call(call2_args, 0));
												a.push([e, call2]);
											};
										} for ( var d = {}, e = ["get_group"].concat( Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++)
										b(j[c]);
										return d;
									};
									b._i.push([e, f, c]);
					};
					b.__SV = 1.2; e = f.createElement("script");
					e.type = "text/javascript";
					e.async = !0;
					e.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === f.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
					g = f.getElementsByTagName("script")[0];
					g.parentNode.insertBefore(e, g);
			}
		})(document, window.mixpanel || []);
		for (const tracker of trackers){
			mixpanel.init(tracker.identifier, {
				debug: true,
				track_pageview: true,
				persistence: "localStorage",
		  }, tracker.identifier);
		}
	},
	track: ({event, identifyParams, metadata, tracker_id}) => {
		if (identifyParams){
			const mixpanelUserId = identifyParams[USER_ID_PARAM_NAME];
			delete identifyParams[USER_ID_PARAM_NAME];
			if (mixpanelUserId){
				mixpanel[tracker_id].identify(mixpanelUserId);
				mixpanel[tracker_id].people.set(identifyParams);
			}
		}
		mixpanel[tracker_id].track(event, metadata);
	}
}

const AmplitudeAnalyticsProvider = {
	init: (trackers) => {
		!function() {
			"use strict";
			!function(e, t) {
			  var r = e.amplitude || { _q: [], _iq: {} };
			  if (r.invoked) e.console && console.error && console.error("Amplitude snippet has been loaded.");
			  else {
				var n = function(e, t) {
				  e.prototype[t] = function() {
					return this._q.push({ name: t, args: Array.prototype.slice.call(arguments, 0) }), this
				  }
				},
				s = function(e, t, r) {
				  return function(n) {
					e._q.push({ name: t, args: Array.prototype.slice.call(r, 0), resolve: n })
				  }
				},
				o = function(e, t, r) {
				  e._q.push({ name: t, args: Array.prototype.slice.call(r, 0) })
				},
				i = function(e, t, r) {
				  e[t] = function() {
					if (r) return { promise: new Promise(s(e, t, Array.prototype.slice.call(arguments))) };
					o(e, t, Array.prototype.slice.call(arguments))
				  }
				},
				a = function(e) {
				  for (var t = 0; t < g.length; t++) i(e, g[t], !1);
				  for (var r = 0; r < m.length; r++) i(e, m[r], !0)
				};
				r.invoked = !0;
				var c = t.createElement("script");
				c.type = "text/javascript",
				c.integrity = "sha384-pY2pkwHaLM/6UIseFHVU3hOKr6oAvhLcdYkoRZyaMDWLjpM6B7nTxtOdE823WAOQ",
				c.crossOrigin = "anonymous",
				c.async = !0,
				c.src = "https://cdn.amplitude.com/libs/analytics-browser-2.11.0-min.js.gz",
				c.onload = function() {
				  e.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK")
				};
				var u = t.getElementsByTagName("script")[0];
				u.parentNode.insertBefore(c, u);
				for (var p = function() { return this._q = [], this },
				  l = ["add", "append", "clearAll", "prepend", "set", "setOnce", "unset", "preInsert", "postInsert", "remove", "getUserProperties"],
				  d = 0; d < l.length; d++) n(p, l[d]);
				r.Identify = p;
				for (var f = function() { return this._q = [], this },
				  v = ["getEventProperties", "setProductId", "setQuantity", "setPrice", "setRevenue", "setRevenueType", "setEventProperties"],
				  y = 0; y < v.length; y++) n(f, v[y]);
				r.Revenue = f;
				var g = ["getDeviceId", "setDeviceId", "getSessionId", "setSessionId", "getUserId", "setUserId", "setOptOut", "setTransport", "reset", "extendSession"],
				  m = ["init", "add", "remove", "track", "logEvent", "identify", "groupIdentify", "setGroup", "revenue", "flush"];
				a(r),
				r.createInstance = function(e) {
				  return r._iq[e] = { _q: [] }, a(r._iq[e]), r._iq[e]
				},
				e.amplitude = r
			  }
			}(window, document)
		  }();
		  
		  window.pixels = window.pixels || {};
		  window.pixels.amplitude = window.pixels.amplitude || {};
		  for (const tracker of trackers){
			window.pixels.amplitude[tracker.identifier] = window.amplitude.createInstance()
			window.pixels.amplitude[tracker.identifier].init(tracker.identifier)
		  }
	},
	track: ({event, metadata, identifyParams, amplitudeId}) => {
		const amplitudeInstance = window.pixels.amplitude[amplitudeId];
		if (identifyParams){
			const identifyEvent = new amplitude.Identify();
			for (const [key, value] of Object.entries(identifyParams)){
				identifyEvent.set(key, value);
			}
			amplitudeInstance.identify(identifyEvent);
		}
		amplitudeInstance.track(event, metadata);
	}
}

const CustomerIOAnalyticsProvider = {
	init: (trackers) => {
		var _cio = _cio || [];
    	(function() {
			var a,b,c;a=function(f){return function(){_cio.push([f].
			concat(Array.prototype.slice.call(arguments,0)))}};b=["load","identify",
			"sidentify","track","page","on","off"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
			var t = document.createElement('script'),
				s = document.getElementsByTagName('script')[0];
			t.async = true;
			t.id    = 'cio-tracker';
			t.setAttribute('data-site-id', trackers[0].identifier);
			t.setAttribute('data-use-array-params', 'true');
			t.src = `https://assets.customer.io/assets/track${trackers[0].additional_data.region === 'Europe' ? '-eu' : ''}.js`;
			s.parentNode.insertBefore(t, s);
    	})();
		window._cio = _cio;
	},
	track: ({event, identifyParams, metadata}) => {
		if (identifyParams){
			_cio.identify(customerIOUserId, identifyParams);
		}
		_cio.track(event, metadata);
	}
}

const XAnalyticsProvider = {
	init: (trackers) => {
		!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
		},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
		a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
		for (const tracker of trackers){
			twq('config', tracker.identifier);
		}
	},
	track: ({event, metadata}) => {
		twq('event', event, metadata);
	}
}

const TrackingProviders = {
	[Providers.META]: FacebookAnalyticsProvider,
	[Providers.GOOGLE_ANALYTICS]: GoogleAnalyticsProvider,
	[Providers.SEGMENT]: SegmentAnalyticsProvider,
	[Providers.TIKTOK]: TikTokAnalyticsProvider,
	[Providers.MIXPANEL]: MixpanelAnalyticsProvider,
	[Providers.AMPLITUDE]: AmplitudeAnalyticsProvider,
	[Providers.CUSTOMER_IO]: CustomerIOAnalyticsProvider,
	[Providers.X]: XAnalyticsProvider,
};

const trackingEventRunner = (data) => {
	TrackingProviders[data.service].track(data);
};

const runAllTrackingEvents = (output) => {
	output.forEach((service) => {
		trackingEventRunner(service);
	});
};

const partitionByProvider = (trackers) => {
	const partition = {};
	for (const tracker of trackers){
		const provider = tracker.analytics_provider.slug;
		if (!partition[provider]){
			partition[provider] = [];
		}
		partition[provider].push(tracker);
	}
	return partition;
}

const initTrackers = (trackers) => {
	console.log(Providers, TrackingProviders)
	const partition = partitionByProvider(trackers)
	for (const provider of Object.keys(partition)){
		TrackingProviders[provider].init(partition[provider]);
	}
}

module.exports = {
	initTrackers,
	runAllTrackingEvents,
};
